import { Pipe, PipeTransform } from "@angular/core";
import { formatCnpj } from "../utils/cnpj.utils";

@Pipe({
  name: "formatCnpj",
})
export class FormatCnpjPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatCnpj(value);
  }
}
